import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import {
  editFeatureSetting,
  featureSettingDetail,
} from "../../../store/featureSetting/actions";

const FeatureSetting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.FeatureSetting);

  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const [formData, setFormData] = useState({
    textMessage: "",
    midChatImageSfw: "",
    midChatImageNsfw: "",
    // aiGenerateImageSfw: "",
    aiGenerateImageNsfw: "",
    profileImage: "",
    // unlockPaywallImage: "",
    // unlockPaywallVideo: "",
    // personalDownloadLicense: "",
    // commercialDownloadLicense: "",
    // videoGeneration: "",
    welcomeToken: "",
    characterGenerate: "",
  });

  const getPlanDetails = () => {
    const callback = (err, res) => {
      if (err) {
        console.error(err);
        toast.error(err);
      } else {
        const plan = res.data; // adjust to res if your API returns fields directly
        console.log(plan, "checking plan");
        setFormData({
          textMessage: plan?.textMessage ?? "",
          midChatImageSfw: plan?.midChatImageSfw ?? "",
          midChatImageNsfw: plan?.midChatImageNsfw ?? "",
          //   aiGenerateImageSfw: plan?.aiGenerateImageSfw ?? "",
          aiGenerateImageNsfw: plan?.aiGenerateImageNsfw ?? "",
          profileImage: plan?.profileImage ?? "",
          characterGenerate: plan?.characterGenerate ?? "",
          // unlockPaywallImage: plan?.unlockPaywallImage ?? "",
          // unlockPaywallVideo: plan?.unlockPaywallVideo ?? "",
          //   personalDownloadLicense: plan?.personalDownloadLicense ?? "",
          //   commercialDownloadLicense: plan?.commercialDownloadLicense ?? "",
          //   videoGeneration: plan?.videoGeneration ?? "",
          welcomeToken: plan?.welcomeToken ?? "",
        });
      }
    };
    dispatch(featureSettingDetail({ callback }));
  };

  useEffect(() => {
    getPlanDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value === "") {
      setFormData({ ...formData, [name]: "" });
      setErrors({ ...errors, [name]: "" });
      return;
    }
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) return;
    setFormData({ ...formData, [name]: numericValue });
    setErrors({ ...errors, [name]: "" });
  };

  const validateFormData = () => {
    const newErrors = {};
    if (formData.textMessage === "" || formData.textMessage === undefined)
      newErrors.textMessage = "Text Message is required";
    if (
      formData.midChatImageSfw === "" ||
      formData.midChatImageSfw === undefined
    )
      newErrors.midChatImageSfw = "Mid-Chat Image (SFW) is required";
    if (
      formData.midChatImageNsfw === "" ||
      formData.midChatImageNsfw === undefined
    )
      newErrors.midChatImageNsfw = "Mid-Chat Image (NSFW) is required";
    // if (
    //   formData.aiGenerateImageSfw === "" ||
    //   formData.aiGenerateImageSfw === undefined
    // )
    //   newErrors.aiGenerateImageSfw = "AI Generate Image (SFW) is required";
    if (
      formData.aiGenerateImageNsfw === "" ||
      formData.aiGenerateImageNsfw === undefined
    )
      newErrors.aiGenerateImageNsfw = "AI Generate Image (NSFW) is required";
    if (
      formData.characterGenerate === "" ||
      formData.characterGenerate === undefined
    )
      newErrors.characterGenerate = "Character Generate is required";
    if (formData.profileImage === "" || formData.profileImage === undefined)
      newErrors.profileImage = "Profile Image is required";
    // if (
    //   formData.unlockPaywallImage === "" ||
    //   formData.unlockPaywallImage === undefined
    // )
    //   newErrors.unlockPaywallImage = "Unlock Paywall Image is required";
    // if (
    //   formData.unlockPaywallVideo === "" ||
    //   formData.unlockPaywallVideo === undefined
    // )
    //   newErrors.unlockPaywallVideo = "Unlock Paywall Video is required";
    // if (
    //   formData.personalDownloadLicense === "" ||
    //   formData.personalDownloadLicense === undefined
    // )
    //   newErrors.personalDownloadLicense =
    //     "Personal Download License is required";
    // if (
    //   formData.commercialDownloadLicense === "" ||
    //   formData.commercialDownloadLicense === undefined
    // )
    //   newErrors.commercialDownloadLicense =
    //     "Commercial Download License is required";
    // if (
    //   formData.videoGeneration === "" ||
    //   formData.videoGeneration === undefined
    // )
    //   newErrors.videoGeneration = "Video Generation is required";
    if (formData.welcomeToken === "" || formData.welcomeToken === undefined)
      newErrors.welcomeToken = "Welcome Token is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    if (!validateFormData()) {
      setIsDisabled(false);
      return;
    }
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
          console.error(err);
        } else {
          toast.success("Feature Settings Updated Successfully");
        }
        setIsDisabled(false);
      };
      dispatch(editFeatureSetting({ data: formData, callback }));
    } catch (error) {
      console.error(error, "<===err");
      setIsDisabled(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form className="mx-auto" onSubmit={handleSubmit}>
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h2 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Feature Setting
                      </h2>
                    </div>
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Text Message
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="textMessage"
                            placeholder="Enter token cost"
                            value={formData.textMessage}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.textMessage && (
                            <small className="text-danger">
                              {errors.textMessage}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Mid-Chat Image (SFW)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="midChatImageSfw"
                            placeholder="Enter token cost"
                            value={formData.midChatImageSfw}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.midChatImageSfw && (
                            <small className="text-danger">
                              {errors.midChatImageSfw}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Mid-Chat Image (NSFW)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="midChatImageNsfw"
                            placeholder="Enter token cost"
                            value={formData.midChatImageNsfw}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.midChatImageNsfw && (
                            <small className="text-danger">
                              {errors.midChatImageNsfw}
                            </small>
                          )}
                        </Col>

                        {/* <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            AI Generate Image (SFW)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="aiGenerateImageSfw"
                            placeholder="Enter token cost"
                            value={formData.aiGenerateImageSfw}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.aiGenerateImageSfw && (
                            <small className="text-danger">
                              {errors.aiGenerateImageSfw}
                            </small>
                          )}
                        </Col> */}

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            {/* AI Generate Image (NSFW) */}
                            AI Generate Image
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="aiGenerateImageNsfw"
                            placeholder="Enter token cost"
                            value={formData.aiGenerateImageNsfw}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.aiGenerateImageNsfw && (
                            <small className="text-danger">
                              {errors.aiGenerateImageNsfw}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Character Generate
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="characterGenerate"
                            placeholder="Enter token cost"
                            value={formData.characterGenerate}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.characterGenerate && (
                            <small className="text-danger">
                              {errors.characterGenerate}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Profile Image
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="profileImage"
                            placeholder="Enter token cost"
                            value={formData.profileImage}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.profileImage && (
                            <small className="text-danger">
                              {errors.profileImage}
                            </small>
                          )}
                        </Col>

                        {/* <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Unlock Paywall Image
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="unlockPaywallImage"
                            placeholder="Enter token cost"
                            value={formData.unlockPaywallImage}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.unlockPaywallImage && (
                            <small className="text-danger">
                              {errors.unlockPaywallImage}
                            </small>
                          )}
                        </Col> */}

                        {/* <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Unlock Paywall Video
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="unlockPaywallVideo"
                            placeholder="Enter token cost"
                            value={formData.unlockPaywallVideo}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.unlockPaywallVideo && (
                            <small className="text-danger">
                              {errors.unlockPaywallVideo}
                            </small>
                          )}
                        </Col> */}

                        {/* <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Personal Download License
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="personalDownloadLicense"
                            placeholder="Enter token cost"
                            value={formData.personalDownloadLicense}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.personalDownloadLicense && (
                            <small className="text-danger">
                              {errors.personalDownloadLicense}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Commercial Download License
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="commercialDownloadLicense"
                            placeholder="Enter token cost"
                            value={formData.commercialDownloadLicense}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.commercialDownloadLicense && (
                            <small className="text-danger">
                              {errors.commercialDownloadLicense}
                            </small>
                          )}
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Video Generation
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="videoGeneration"
                            placeholder="Enter token cost"
                            value={formData.videoGeneration}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.videoGeneration && (
                            <small className="text-danger">
                              {errors.videoGeneration}
                            </small>
                          )}
                        </Col> */}

                        <Col md="6" className="my-2">
                          <label className="form-label text-dark m-0 pb-1 fw-sbold text-uppercase">
                            Welcome Token
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="welcomeToken"
                            placeholder="Enter token amount"
                            value={formData.welcomeToken}
                            onChange={handleChange}
                            min="0"
                          />
                          {errors.welcomeToken && (
                            <small className="text-danger">
                              {errors.welcomeToken}
                            </small>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="text-uppercase fw-sbold w-100 btn-danger"
                            onClick={() => navigate("/subscription-plan")}
                            type="button"
                          >
                            Cancel
                          </Button>
                        </Col>
                        <Col md="7" className="my-2">
                          <Button
                            disabled={isDisabled}
                            type="submit"
                            className="text-uppercase fw-sbold w-100 btn-primary"
                          >
                            {isDisabled ? "Updating..." : "Update"}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FeatureSetting;
